import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import Section from '../Section';
import Spacing from '../Spacing';
import List from '../List';
import { pageTitle } from '../../helpers/PageTitle';

const credentialsData = [
  {
    title: 'MBChB',
    subTitle: 'Medical Degree',
  },
  {
    title: 'Registered with the HPCSA',
    subTitle: 'Health Professions Council of South Africa',
  },
  {
    title: 'Member of SAMA',
    subTitle: 'South African Medical Association',
  },
];

const experienceData = [
  {
    title: 'General Practitioner — Wyebank, Durban',
    subTitle: 'Private practice serving the local community.',
  },
  {
    title: 'Family medicine',
    subTitle:
      'Years of clinical experience caring for patients of every age.',
  },
  {
    title: 'Continuing Medical Education',
    subTitle:
      'Ongoing training to stay current with evidence-based practice.',
  },
];

const interestsData = [
  { title: 'Chronic disease management' },
  { title: 'Preventive care and wellness' },
  { title: 'Paediatric primary care' },
  { title: "Women's and men's health" },
];

export default function Doctor() {
  pageTitle('Dr. L.D. Ramiah | Doctor');
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/doctors/banner_bg.svg"
        imgUrl="/images/doctors/banner_img.png"
        title="Dr. L.D. Ramiah"
        subTitle="General Practitioner • Wyebank, Durban"
      />
      <Section topMd={200} topLg={150} topXl={110}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <img
                src="/images/doctors/doctor_1.png"
                alt="Dr. L.D. Ramiah"
                className="cs_radius_25 w-100"
              />
            </div>
            <div className="col-lg-1" />
            <div className="col-lg-6">
              <h2 className="cs_fs_50 cs_medium mb-0">About the Doctor</h2>
              <Spacing md="25" lg="25" xl="25" />
              <p className="cs_fs_20 mb-0 cs_heading_color">
                Dr. L.D. Ramiah is a general practitioner based at 5 Motala
                Road, Wyebank, Durban. The practice provides comprehensive
                primary care for individuals and families, from
                everyday consultations and preventive screenings to chronic
                disease management and minor in-office procedures.
              </p>
              <Spacing md="20" lg="20" xl="20" />
              <p className="cs_fs_20 mb-0 cs_heading_color">
                Patients can expect unhurried consultations, careful
                examination, and clear explanations so that every visit
                leaves them better informed about their own health.
              </p>
              <Spacing md="40" lg="40" xl="40" />
              <h3 className="cs_fs_24 cs_semibold mb-0">Languages spoken</h3>
              <Spacing md="10" lg="10" xl="10" />
              <p className="cs_fs_20 mb-0">English</p>
            </div>
          </div>
        </div>
      </Section>

      <Section topMd={185} topLg={140} topXl={100}>
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <List
                heading="Credentials"
                iconUrl="/images/icons/award.svg"
                data={credentialsData}
              />
              <Spacing md="40" lg="40" xl="40" />
            </div>
            <div className="col-lg-4">
              <List
                heading="Experience"
                iconUrl="/images/icons/award.svg"
                data={experienceData}
              />
              <Spacing md="40" lg="40" xl="40" />
            </div>
            <div className="col-lg-4">
              <List
                heading="Special Interests"
                iconUrl="/images/icons/award.svg"
                data={interestsData}
              />
            </div>
          </div>
        </div>
      </Section>

      <Section topMd={185} topLg={140} topXl={100}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <h2 className="cs_fs_50 cs_medium mb-0">Approach to Care</h2>
              <Spacing md="25" lg="25" xl="25" />
              <p className="cs_fs_20 mb-0 cs_heading_color">
                A family doctor's role is more than treating illness,
                it is being a trusted, long-term partner in your health.
                Dr. Ramiah's practice is built around listening carefully,
                explaining clearly, and coordinating consistent, community-
                focused care for every patient.
              </p>
            </div>
          </div>
        </div>
      </Section>

      <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
        className="cs_footer_margin_0"
      >
        <BannerSectionStyle4
          bgUrl="images/about/banner_bg_2.jpeg"
          title="Have a question for Dr. Ramiah? <br />Get in touch."
          subTitle="Reach out through the contact page and we'll respond as soon as we can."
          center
        />
      </Section>
    </>
  );
}
